import { Api } from "../config/request";

export default {
  getUploadUrl(payload) {
    return Api.post("/personal-info/request", payload);
  },
};
